import { Component } from '@angular/core';

@Component({
  selector: 'pill-container',
  templateUrl: './pill-container.component.html',
  standalone: false,
})
export class PillContainerComponent {
  constructor() {}
}
